<template>
  <SoAlert title="To issue a new bill we need a recent meter reading">
    <p>Last reading submission was:</p>
    <SoSkeleton
      v-if="current.meterpoints.isFetching"
      type="list-item-two-line"
      class="my-4"
    />
    <div v-else class="my-4">
      <p v-for="meterpoint in current.meterpoints.data" :key="meterpoint.id">
        {{ meterpoint.meterpointType }} {{ meterpoint.identifier }}
        <span class="font-weight-medium">
          - {{ formatDate(meterpoint.latestRead?.date) }}
        </span>
      </p>
    </div>
    <p>Submit new readings to proceed.</p>
  </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { formatDate } from "@/helpers/dateHelper"
  import SoAlert from "@/components/SoAlert.vue"
  import SoSkeleton from "@/components/SoSkeleton.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoSkeleton,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        formatDate,
      }
    },
  })
</script>
